import React from 'react'
import { Row, Col } from 'react-bootstrap'

import useContainerContext from '../../containerContext'
import { FilterCompanies, FilterDateRange } from '../../filter'
import SearchBox from '../../searchBox'
import { FormComboBox } from '../../formControl'

const insuranceOptions = [
  { value: 'all', label: 'ALL' },
  { value: 'Customer Pay', label: 'Customer Pay' },
  { value: 'Allstate', label: 'Allstate' },
  { value: 'Ameriprise', label: 'Ameriprise' },
  { value: 'Amica', label: 'Amica' },
  { value: 'AIG', label: 'AIG' },
  { value: 'AXA Insurance Company', label: 'AXA Insurance Company' },
  { value: 'Chubb Insurance', label: 'Chubb Insurance' },
  { value: 'CNA Insurance Co', label: 'CNA Insurance Co' },
  { value: 'Encompass Insurance Company', label: 'Encompass Insurance Company' },
  { value: 'Erie', label: 'Erie' },
  { value: 'Esurance', label: 'Esurance' },
  { value: 'Farmers', label: 'Farmers' },
  { value: 'GEICO', label: 'GEICO' },
  { value: 'The General Insurance', label: 'The General Insurance' },
  { value: 'Hartford', label: 'Hartford' },
  { value: 'Kemper', label: 'Kemper' },
  { value: 'Liberty Mutual', label: 'Liberty Mutual' },
  { value: 'Markel Corp', label: 'Markel Corp' },
  { value: 'MetLife', label: 'MetLife' },
  { value: 'Nationwide', label: 'Nationwide' },
  { value: 'Progressive', label: 'Progressive' },
  { value: 'Pure Insurance', label: 'Pure Insurance' },
  { value: 'QBE', label: 'QBE' },
  { value: 'Safeco', label: 'Safeco' },
  { value: 'Sentry', label: 'Sentry' },
  { value: 'State Farm', label: 'State Farm' },
  { value: 'Travelers', label: 'Travelers' },
  { value: 'USAA', label: 'USAA' },
  { value: 'Zurich Insurance', label: 'Zurich Insurance' },
]

const statusOptions = [
  { value: 'all', label: 'ALL' },
  { value: 'open', label: 'Open' },
  { value: 'closed', label: 'Closed' },
]

const sourceOptions = [
  { value: 'all', label: 'ALL' },
  { value: 'Internal', label: 'Internal' },
  { value: 'CCC', label: 'CCC' },
  { value: 'Client', label: 'Client' },
]

const Filter = () => {
  const { state, setState } = useContainerContext()
  const { filter } = state.query

  // Same debounced SearchBox as the estimates and invoices lists; a new term
  // always starts from the first page.
  const onSearch = search => {
    setState(prev => ({
      ...prev,
      query: { ...prev.query, page: 1, filter: { ...prev.query.filter, search } },
    }))
  }

  const onFilterChange = (field) => (value) => {
    setState(prev => ({
      ...prev,
      query: { ...prev.query, page: 1, filter: { ...prev.query.filter, [field]: value } },
    }))
  }

  const onDateRangeChange = ({ startDate, endDate, value }) => {
    setState(prev => ({
      ...prev,
      query: {
        ...prev.query,
        page: 1,
        filter: { ...prev.query.filter, dateRange: value, startDate, endDate },
      },
    }))
  }

  return (
    <div className='adas-filter mb-4'>
      <Row className='g-3 mb-3'>
        <Col xs={12} md={6} lg={3}>
          <SearchBox
            autoComplete='off'
            onChangeMode
            delay={500}
            blurOnSearch={false}
            defaultValue={filter.search}
            placeholder='Report #, VIN or Stock/RO'
            onChange={onSearch}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <FormComboBox
            label={() => <span className='filter-label'>Status</span>}
            options={statusOptions}
            fluid
            className='light'
            size='medium'
            value={filter.status}
            onChange={onFilterChange('status')}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <FilterCompanies
            label='Vendor'
            fluid
            className='light'
            size='medium'
            value={filter.vendor}
            onChange={onFilterChange('vendor')}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <FormComboBox
            label={() => <span className='filter-label'>Insurance Carrier</span>}
            options={insuranceOptions}
            fluid
            className='light'
            size='medium'
            value={filter.insuranceCarrier || 'all'}
            onChange={onFilterChange('insuranceCarrier')}
          />
        </Col>
      </Row>
      <Row className='g-3'>
        <Col xs={12} md={6} lg={3}>
          <FilterDateRange
            fluid
            className='light'
            size='medium'
            value={filter.dateRange}
            onChange={onDateRangeChange}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <FormComboBox
            label={() => <span className='filter-label'>Source</span>}
            options={sourceOptions}
            fluid
            className='light'
            size='medium'
            value={filter.source || 'all'}
            onChange={onFilterChange('source')}
          />
        </Col>
      </Row>
    </div>
  )
}

export default Filter
